import { state } from 'cerebral'
import schemaSettings from '../../../shared/schemas/analytics-live-schema'
import apiClient from '../../lib/util/api-client'
import { createCrudState, redirectUnauthorized } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'
import { createProviders } from '../providers'
import { current, metrics } from './computed'
import * as sequences from './sequences'

const { analyticsLiveSchema: schema } = schemaSettings
const service = apiClient.service('analytics-live')

export default ({ name, app }) => {
  app.on('initialized', () => {
    const updateEntities = app.getSequence('analyticsLive.updateEntities')
    service.on('patched', (location) => updateEntities({ entities: { analyticsLive: [location] } }))
  })

  return {
    state: {
      ...createCrudState({ entityType: 'analyticsLive', storePrefix: name }),
      current,
      metrics,
    },
    sequences,
    providers: createProviders({ name, service, schema }),
    catch: [
      redirectUnauthorized(),
      [
        Error,
        showFeedbackFromError({ title: 'We encountered an error' }),
        ({ props: { error, errorPath = name }, store }) => {
          store.set(state`errors.${errorPath}`, error)
        },
      ],
    ],
  }
}
